export const AST_SIGNMAIL_HANDOFF_DURATION_MS = 5000;

/** Core `ASTSignMailMode` value that allows auto AST SignMail routing. */
export const AST_SIGNMAIL_MODE_ENABLED = 1;
